import React, { useState } from "react";
import {
  addRental,
  addSubs,
  addWallet,
  getNotificationByUser,
  getRentHistory,
  getSubscriptionHistory,
  userWallet,
} from "../../utils/api";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  Button,
  Drawer,
  Form,
  Image,
  Input,
  InputNumber,
  Modal,
  Select,
  Table,
  Tag,
  Typography,
  message,
} from "antd";

const Notifications = ({ row }) => {
  const [visible, setVisible] = useState(false);
  const { data, isLoading, refetch } = useQuery({
    queryKey: ["notifications", row._id, visible],
    queryFn: async () => await getNotificationByUser(row._id),
    enabled: visible,
  });
  console.log(data);

  return (
    <div>
      <Button
        style={{
          width: "100%",
        }}
        type="primary"
        onClick={() => setVisible(true)}
      >
        Notifications
      </Button>
      <Drawer
        title={"Notifications"}
        confirmLoading={isLoading}
        open={visible}
        onClose={() => setVisible(false)}
        footer={null}
        width={800}
      >
        <Table
          dataSource={data}
          columns={[
            {
              title: "Title",
              dataIndex: "title",
            },
            {
              title: "Description",
              dataIndex: "description",
            },
            {
              title: "Image",
              dataIndex: "image",
              render: (text) => (
                <Image src={text} style={{ width: 100, height: 100 }} />
              ),
            },
            {
              title: "Date",
              dataIndex: "date",
            },
            {
              title: "Read",
              dataIndex: "read",
              render: (text) => (
                <Tag color={text ? "green" : "red"}>
                  {text ? "Read" : "Unread"}
                </Tag>
              ),
            },
          ]}
        />
      </Drawer>
    </div>
  );
};

export default Notifications;
